import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=1218c7cf&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1218c7cf')) {
      api.createRecord('1218c7cf', component.options)
    } else {
      api.reload('1218c7cf', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=1218c7cf&", function () {
      api.rerender('1218c7cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ag2xDxrAcXFM/JS/comp/ImgFallback.vue"
export default component.exports